module.exports = __webpack_public_path__ + "img/PL08324.b02abe2b.png";